import React, { Component } from 'react';
import uniqWith from 'lodash/uniqWith';

import NewslettersService from '../../../services/newsletters';
import formattersService from '../../../services/formatters';
import { tokenToTagsMapping } from '../../../services/twitter/tags';
import './newsletter-generator.css';

const twitterTagsByTag = {
  'angular': ['javascript', 'frontend', 'webdev'],
  'typescript': ['typescript', 'frontend', 'webdev'],
  'react': ['javascript', 'frontend', 'webdev'],
  'vuejs': ['javascript', 'frontend', 'webdev'],
  'graphql': ['javascript', 'frontend', 'webdev'],
  'nodejs': ['javascript', 'webdev'],
  'javascript': ['webdev', 'frontend'],
  'golang': [],
  'frontenddev': ['frontenddev', 'webdev'],
  'web': ['webdev'],
  'flutter': ['mobiledev', 'androiddev', 'iosdev', ],
  'kotlin': ['androiddev', 'mobiledev', ],
  ux: ['ux'],
  php: ['php'],
  docker: ['docker'],
  machinelearning: ['machinelearning', 'ml', 'ai',],
  gamedev: ['gamedev', 'gamedevelopment'],
  aws: ['aws'],
  python: ['python', 'pythondev'],
  java: ['java', 'javadev'],
  html: ['html', 'webdev', 'frontenddev'],
  css: ['css', 'webdev', 'frontenddev'],

  csharp: ['csharp'],
  opensource: ['opensource',],
  db: ['db', 'database',],
  ruby: ['ruby',],
  devops: ['devops',],
  security: ['security',],
  reactnative: ['ReactNative',],
  linux: ['linux',],
};  

const twitterTweetNewsletterName = {
  'angular': '#Angular #TypeScript',
  undefined: '#Angular #TypeScript',
  'typescript': '#TypeScript',
  'react': '#ReactJS',
  'vuejs': '#VueJS',
  'graphql': '#GraphQL',
  'nodejs': '#NodeJS',
  'javascript': '#JavaScript',
  'golang': '#GoLang',
  'frontenddev': 'Front End',
  'web': '#Web',
  'flutter': '#Flutter',
  'kotlin': '#Kotlin',
  'android': '#Android',
  ux: '#UX',
  php: '#PHP',
  docker: '#Docker',
  machinelearning: '#MachineLearning',
  gamedev: '#GameDev',
  aws: '#AWS',
  python: '#Python',
  java: '#Java',
  html: '#HTML',
  css: '#CSS',

  csharp: '#CSharp',
  opensource: '#OpenSource',
  db: '#Database',
  ruby: '#Ruby',
  devops: '#DevOps',
  security: '#Security',
  reactnative: '#ReactNative',
  linux: '#Linux',
};

class NewsletterGenerator extends Component {
  copyToClipboardInput = null;
  
  constructor(props) {
    super(props);

    this.state = {
      isError: false
    };

    this.generateNewsCandidate(props);
  }

  // componentDidUpdate(props) {
  //   this.generateNewsCandidate(props);
  // }

  getTweetTemplateByTagName(tag, id) {
    let twitterDescription = `📰👨‍💻 ${twitterTweetNewsletterName[tag]} Trends #${id}:  https://dormoshe.io/newsletters`;

    if (tag) {
      twitterDescription += `/ag/${tag}`;
    }

    twitterDescription += `/${id}?utm_source=twitter&utm_campaign=twitter #dormosheio`;

    const twitterTags = tag ? twitterTagsByTag[tag] : twitterTagsByTag.angular
    twitterDescription += twitterTags.map(x => ` #${x}`).join('');
    
    return twitterDescription;
  }

  generateNewsletterDescription(articles) {
    return `In this week, you can read about ${
      articles
      .filter(article => article.isPartOfNewsletter)
      .map(article => 
        article.title
          .toLowerCase()
          .split(' ')
          .map(token => {
            const transparentChars = ',.:-;';

            if (tokenToTagsMapping[token]) return tokenToTagsMapping[token];

            if (transparentChars.indexOf(token[0]) > -1) {
              const candidate = tokenToTagsMapping[token.slice(1)];
              if (candidate) return `${token[0]}${candidate}`;

              return token;
            }

            if (transparentChars.indexOf(token[token.length - 1]) > -1) {
              const candidate = tokenToTagsMapping[token.slice(0, token.length - 1)];
              if (candidate) return `${candidate}${token[token.length - 1]}`;

              return token;
            }

            return token;
          })
          .join(' ')
      ).join(', ')
    }.`;
  }

  generateNewsCandidate(props) {
    const tag = props.match.params.tag;

    const queryStringStr = (props.location.search || '').replace('?', '');

    // postsNum / ids
    const queryStrMap = queryStringStr
      .split('&')
      .filter(x=> x && x.length > 0)
      .reduce((all, queryStr) => {
        const [key, value] = queryStr.split('=');
        return {
          ...all,
          [key]: value
        };
      }, {});

    const postsNum = +queryStrMap.postsNum || null;
    const dailyNewsIds = JSON.parse(queryStrMap.ids || '[]') || [];

    NewslettersService.generateNewsletterCandidate(dailyNewsIds, tag, postsNum)
      .then((newsletter) => {
        const twitterDescription = this.getTweetTemplateByTagName(newsletter.universalTagName, newsletter._id);
        const twitterDescriptionLength = this.calcTwitterDescriptionLength(twitterDescription);

        const updatedArticles = newsletter.articles.map(post => {
          return {
            ...post,
            isPartOfNewsletter: true,
          };
        });

        const updatedTweets = newsletter.tweets.map(tweet => {
          return {
            ...tweet,
            isPartOfNewsletter: true,
          };
        });

        this.setState({ 
          ...newsletter,
          mailchimpDescriptionLength: newsletter.mailchimpDescription.length,
          description: this.generateNewsletterDescription(updatedArticles),
          articles: updatedArticles,
          tweets: updatedTweets,
          twitterDescription,
          twitterDescriptionLength,
          additionalTwitterRefs: [ 'dormoshe' ],
          tag: props.match.params.tag,
          mainImg: updatedArticles[0].imgUrl,
        });
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  onCopyClick = (i) => {
    return () => {
      this.copyToClipboardInput.value = this.state.articles[i].imgSrc;
      this.copyToClipboardInput.select();
      document.execCommand("Copy");
    }
  }

  getSetMainImgByClick = (i) => {
    return () => {
      this.setState((state) => {
        return {
          mainImg: this.state.articles.filter(article => article.isPartOfNewsletter)[i].imgUrl,
        }
      })
    }
  };

  getArticleOnChange = (postId, field) => {
    return (event) => {
      const newValue = event.target.value;
      this.setState((prevState) => {
        return {
          articles: prevState.articles.map(post => {
            const additionals = {};

            if (post._id === postId) {
              if (field.startsWith('paragraph')) {
                const parIndex = +field.split('_')[1];
                additionals.paragraphs = [
                  ...post.paragraphs
                ];

                additionals.paragraphs[parIndex] = newValue;
              }
              else if (field === 'twitterRefs') {
                additionals.twitterRefs = newValue.split(',').map(r=>r.trim());
              }
              else {
                additionals[field] = newValue;
              }
            }

            return {
              ...post,
              ...additionals
            };
          })
        }
      })
    }
  }

  onAdditionalTwitterRefsChange = (event) => {
    const newValue = event.target.value;
    this.setState((prevState) => {
      return {
        additionalTwitterRefs: newValue.split(',')
      };
    });
  }

  addFromTwitterFallback = (ref, postId) => {
    this.setState(({ articles }) => {
      return {
        articles: articles.map(post => {
          if (post._id !== postId) return post;
          
          const twitterRefs = uniqWith([...post.twitterRefs, ref], (r1, r2) => {
            return r1.toLowerCase() === r2.toLowerCase();
          });

          return {
            ...post,
            twitterRefs: twitterRefs,
            twitterRefsFallback: post.twitterRefsFallback.filter(twitterRef => twitterRef !== ref),
          };
        })
      }
    })
  }

  getFinalTwitterRefs = () => {
    const candidateRefs = [
      ...this.state.articles.filter(article => article.isPartOfNewsletter).reduce((res, x) => [...res, ...x.twitterRefs], []),
      ...this.state.additionalTwitterRefs,
      ...this.state.tweets.filter(tweet => tweet.isPartOfNewsletter).reduce((res, x) => [...res, ...x.twitterRefs], []),
    ].map(r=>r.trim()).filter(r=>r);

    return uniqWith(candidateRefs, (r1, r2) => {
      return r1.toLowerCase() === r2.toLowerCase();
    });
  }

  onSavePosts = () => {
    const articles = this.state.articles
      .filter(article => article.isPartOfNewsletter)
      .map(post => {
        return {
          ...post,
          twitterRefs: post.twitterRefs.map(r=>r.trim()).filter(r=>r),
          paragraphs: post.paragraphs.map(p=>p && p.trim()).filter(p => p)
        };
      });

    const tweets = this.state.tweets
      .filter(tweet => tweet.isPartOfNewsletter)
      .map(tweet => {
        return {
          tweetID: tweet.tweetID,
          html: tweet.html.replace('blockquote ', 'blockquote data-width="300"'),
          grade: tweet.grade,
          twitterRefs: tweet.twitterRefs,
        };
      });
    
    const { _id, description, twitterDescription, mailchimpDescription, date, tag, mainImg, editor, } = this.state;
    
    const newsletter = {
      _id,
      articles,
      tweets,
      twitterRefs: this.getFinalTwitterRefs(),
      editor,
      description,
      twitterDescription,
      mailchimpDescription,
      date,
      universalTagName: tag,
      mainImg,
    };

    NewslettersService.generateNewsletter(newsletter, tag)    
      .then(() => {
        window.location.href = 'https://dormoshe.io';
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  getImg = (imgUrl) => {
    if (!imgUrl) return '';
    return <img src={imgUrl} alt='post' height='150px'/>;
  }

  getOnCheckboxClicked = (postId, field) => {
    return () => {
      this.setState((prevState) => {
        const articles = prevState.articles.map(post => {
          const additionals = {};
          if (post._id === postId) {
            additionals[field] = post[field] === true ? false : true
          };

          return {
            ...post,
            ...additionals
          };
        });

        return {
          articles: articles,
          description: this.generateNewsletterDescription(articles),
        };
      })
    }
  }

  getOnTweetCheckboxClicked = (tweetID, field) => {
    return () => {
      this.setState((prevState) => {
        const tweets = prevState.tweets.map(tweet => {
          const additionals = {};
          if (tweet.tweetID === tweetID) {
            additionals[field] = tweet[field] === true ? false : true;
          }

          return {
            ...tweet,
            ...additionals
          };
        });

        return {
          tweets,
        };
      })
    }
  }

  getUseDefaultTagImg = (postId) => {
    return () => {
      this.setState((prevState) => {
        const articles = prevState.articles.map(post => {
          const additionals = {};
          if (post._id === postId) {
            additionals.imgUrl = `https://dormoshe.io/images/general/${ prevState.tag }.png`;
          };

          return {
            ...post,
            ...additionals
          };
        });

        return {
          articles: articles,
        }
      });
    };    
  };


  renderArticlesParts = () => {
    return (
        <section className='articles-container'>
          {
            this.state.articles.map((post, i) => 
              <div key={post._id} className={ !post.isPartOfNewsletter ? 'hide' : '' }>
                <div>
                  <input 
                    type='checkbox' 
                    checked={post.isPartOfNewsletter}
                    onChange={this.getOnCheckboxClicked(post._id, 'isPartOfNewsletter')}/>

                  <span>{i + 1} out of {this.state.articles.length} / {post.universalTagName} / id: {post._id}</span>
                </div>
                
                { post.grade && <div><label>Grade: {post.grade}</label></div> }

                <input 
                  className='long-input'
                  value={post.title} 
                  onChange={this.getArticleOnChange(post._id, 'title')} /> 

                { 
                  post.isPartOfNewsletter && <div>
                    <div className='post-paragraphs'>
                      <label>Paragraphs:</label>
                      <textarea 
                        className='long-input'
                        required
                        value={(post.paragraphs.length > 0 && post.paragraphs[0]) || ''} 
                        onChange={this.getArticleOnChange(post._id, 'paragraph_0')}
                        rows='6' />
                      
                      <textarea 
                        className='long-input'
                        value={(post.paragraphs.length > 1 && post.paragraphs[1]) || ''} 
                        onChange={this.getArticleOnChange(post._id, 'paragraph_1')}                    
                        rows='6' />
                      
                      {
                        post.paragraphs.length > 2 && 
                          <textarea 
                            className='long-input'
                            value={(post.paragraphs.length > 2 && post.paragraphs[2]) || ''} 
                            onChange={this.getArticleOnChange(post._id, 'paragraph_2')}                    
                            rows='6' />
                      }
                    </div>

                    <div>
                      <label>Writer:</label>
                      <input 
                        value={post.writer || ''}
                        onChange={this.getArticleOnChange(post._id, 'writer')} /> 
                    </div>

                    <div>
                      <label>Publication:</label>
                      <input 
                        value={post.publication || ''}
                        onChange={this.getArticleOnChange(post._id, 'publication')} /> 
                    </div>

                    <div>
                      <label>TwitterRefs:</label>
                      <input 
                        value={post.twitterRefs.join(',')}
                        className={post.twitterRefs.length !== 2 ? 'problem' : ''}
                        onChange={this.getArticleOnChange(post._id, 'twitterRefs')} /> 
                      
                      { post.twitterRefsFallback && post.twitterRefsFallback.length > 0 && <label>Twitter Suggestions:</label> }
                      { post.twitterRefsFallback && post.twitterRefsFallback.map(twitterRef => <button onClick={() => this.addFromTwitterFallback(twitterRef, post._id)}>{ twitterRef }</button>) }                      
                    </div>



                    <div>
                      <label>Source date:</label>
                      <i>{post.sourceDate || ''}</i>
                    </div>
                    
                    {/*<div>
                      <label>Publish date:</label>
                      {post.date}
                    </div>*/}
                    
                    <div>
                      <label>url:</label>
                      <i>{post.url || ''}</i>

                      <span className='direct-link'><a href={post.url} target='_blank'>Direct Link</a></span>
                    </div>

                    <div>
                      <label>SourceUrl:</label>
                      <i>{post.sourceUrl || ''}</i>

                      <span className='direct-link'><a href={post.sourceUrl} target='_blank'>Direct Link</a></span>
                    </div>

                    <div>
                      <label>ImgUrl:</label>
                      <input 
                        className='long-input'
                        value={post.imgUrl || ''}
                        onChange={this.getArticleOnChange(post._id, 'imgUrl')} /> 
                    </div>

                    <div>
                      {this.getImg(post.imgUrl)}
                      <button onClick={this.getUseDefaultTagImg(post._id)}>Use default tag image</button>                      
                    </div>
                    <hr/>
                  </div>
                }
              </div>
            )
          }
        </section>
      );
  }

  renderTweetsParts = () => {
    return (
        <section className='tweets-container'>
          {
            this.state.tweets.map((tweet, i) => 
              <div key={tweet.tweetID} className={ !tweet.isPartOfNewsletter ? 'hide' : '' }>
                <div>
                  <input 
                    type='checkbox' 
                    checked={tweet.isPartOfNewsletter}
                    onChange={this.getOnTweetCheckboxClicked(tweet.tweetID, 'isPartOfNewsletter')}/>

                  <span>{i + 1} out of {this.state.tweets.length}</span>
                </div>
                
                { tweet.grade && <div><label>Grade: {tweet.grade}</label></div> }

                { tweet.isPartOfNewsletter && <div dangerouslySetInnerHTML={{ __html: tweet.html }} /> }
              </div>
            )
          }
        </section>
      );
  }

  getOnGeneralFieldChange = (field) => { 
    return (event) => {
      const newValue = event.target.value;
      this.setState((prevState) => {
        const res = {};
        res[field] = newValue;
        return res;
      });
    }
  }

  calcTwitterDescriptionLength(twitterDescription, urlLength = 75) {
    // length of twitter link is 24 + 5 gap
    return twitterDescription.length - urlLength + 24 + 5; 
  }

  setTwitterDescription = (event) => {
    const twitterDescription = event.target.value;
    const newLength = this.calcTwitterDescriptionLength(twitterDescription);
    // if (newLength > 280) return;

    this.setState({
      twitterDescription,
      twitterDescriptionLength: newLength,
    });
  };

  setMailchimpDescription = (event) => {
    const mailchimpDescription = event.target.value;
    this.setState({
      mailchimpDescription,
      mailchimpDescriptionLength: mailchimpDescription.length,
    });
  };

  render() {
    let body = 'Processing...';
    if (this.state && this.state.articles) {
      const newsArticles = this.state.articles;
      const twitterRefs = this.getFinalTwitterRefs();
      const titles = newsArticles
        .filter(article => article.isPartOfNewsletter)
        .map((x, i) => {
          return (
            <div key={`article-${i}`}>
              { x.title.toLowerCase() }
            </div>
          );
        });

      const imgsPart = newsArticles
        .filter(article => article.isPartOfNewsletter)
        .map((x, i) => (
          <div key={`article-${i}`}>
            <img src={x.imgUrl} height='50' width='50'/>
            <button onClick={this.onCopyClick(i)}>Copy</button>
            <button onClick={this.getSetMainImgByClick(i)}>Set as Main Img</button>
            {/*<div>{x.imgSrc}</div>*/}
            <hr />
          </div>
        ));

      const articlesPart = this.renderArticlesParts();
      const tweetsPart = this.renderTweetsParts();
      const { twitterDescriptionLength, mailchimpDescriptionLength, tweets, } = this.state;
      const selectedArticlesLength = newsArticles.filter(article => article.isPartOfNewsletter).length;
      const selectedTweetsLength = tweets.filter(tweet => tweet.isPartOfNewsletter).length;
      
      body = (
        <div>
          {articlesPart}
          {tweetsPart}

          <section>
            <h3>TwitterRefs ({twitterRefs.length})</h3>
            <p>{twitterRefs.join(' ')}</p>
            <label>Additional refs</label>
            <input 
              value={this.state.additionalTwitterRefs.join(',') || ''}
              onChange={this.onAdditionalTwitterRefsChange}/>
          </section>

          <section>
            <h3>Summaries</h3>
            {titles}

            <label>Main Image</label>
            <section>
              <input 
                className='long-input'
                value={this.state.mainImg || ''}
                onChange={this.getOnGeneralFieldChange('mainImg')}/>
              
              <img src={this.state.mainImg} height='50' width='50'/>
            </section>

            <label>Newsletter Description</label>
            <textarea 
              className='long-input'
              required
              value={this.state.description} 
              onChange={this.getOnGeneralFieldChange('description')}
              rows='6' />

            <label>Twitter Description</label>
            <textarea 
              className='long-input'
              required
              value={this.state.twitterDescription} 
              onChange={this.setTwitterDescription}
              style={ twitterDescriptionLength > 280 ? { border: '2px solid red'} : {}}
              rows='6' />

            <div style={ twitterDescriptionLength > 280 ? { color: 'red' } : {} }>
              ~{ this.state.twitterDescriptionLength } / 280 
            </div>

            <label>Mailchimp Description</label>
            <textarea 
              className='long-input'
              required
              value={this.state.mailchimpDescription} 
              onChange={this.setMailchimpDescription}
              style={ mailchimpDescriptionLength > 150 ? { border: '2px solid red'} : {}}
              rows='6' />

            <div style={ mailchimpDescriptionLength > 150 ? { color: 'red' } : {} }>
              { this.state.mailchimpDescriptionLength } / 150 
            </div>            
          </section>

          <section>
            <h3>Images</h3>
            {imgsPart}
            <input ref={(r) => { this.copyToClipboardInput = r }} />            
          </section>

          <input type='button' value='Save' onClick={this.onSavePosts}/>
          
          <div className='twitter-counter-ballon' style={{ 'background-color': (selectedArticlesLength === 6 && selectedTweetsLength === 3 ? '#73ff00' : 'lightblue') }}>
            {twitterRefs.length} <br /> Twitter Refs
            <br />
            <div style={{ 'background-color': (selectedArticlesLength === 6 ? '#73ff00' : 'inherit') }}>
              {selectedArticlesLength} / {newsArticles.length} <br /> Articles
            </div>
            <div style={{ 'background-color': (selectedTweetsLength === 3 ? '#73ff00' : 'inherit') }}>            
              {selectedTweetsLength} / {tweets.length} <br /> Tweets            
            </div>
          </div>
        </div>
      );
    }

    if (this.state.isError) {
      body = 'Error';
      body += this.state.errorMessage ? `: ${this.state.errorMessage}` : '';
    }

    return (
      <section className='regular-page newsletter-generator'>
        {body}
      </section>
    );
  }
}

export default NewsletterGenerator;
